import { AUTH_PATHS } from "@/constants";
import { FeatureFlag } from "@/constants/featureFlags";
import { useFeatureFlag } from "@/hooks/useFeatureFlag";
import { Link } from "react-router-dom";

export const WaitlistAuthLinks = () => {
  const signupEnabled = useFeatureFlag(FeatureFlag.SignupEnabled);

  return (
    <p className="text-center text-sm text-muted-foreground">
      {!signupEnabled ? (
        <>
          Already have an account?{" "}
          <Link
            to={AUTH_PATHS.SIGNIN}
            className="font-semibold text-primary transition-colors hover:text-primary-hover"
          >
            Sign in
          </Link>
        </>
      ) : (
        <>
          Prefer a full account now?{" "}
          <Link
            to={AUTH_PATHS.SIGNUP}
            className="font-semibold text-primary transition-colors hover:text-primary-hover"
          >
            Sign up
          </Link>
          {" · "}
          <Link
            to={AUTH_PATHS.SIGNIN}
            className="font-semibold text-primary transition-colors hover:text-primary-hover"
          >
            Sign in
          </Link>
        </>
      )}
    </p>
  );
};
